import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// MDL store
import Login from './modules/authentication/Login.js';
import ForgotPassword from './modules/authentication/ForgotPassword.js';
import Signup from './modules/authentication/Signup.js';
import Courses from './modules/homepage/Courses';
import LearningProfile from './modules/authentication/LearningProfile';
import Profile from './modules/homepage/GetProfile';
import Overview from './modules/homepage/Overview.js';
import UpdateProfile from './modules/authentication/UpdateProfile';
import Template from './modules/template/TemplateModule';
import Language from './modules/language/LanguageModule';
import Score from './modules/score/ScoreModule';
import Necessary from './modules/necessary/NecessaryModule';
import v3 from './modules/v3/v3Module.js';
import v3Data from './modules/v3/v3Data.js';
import v4 from './modules/v4/v4Module.js';
import v4Data from './modules/v4/v4Data.js';

Vue.use(Vuex);
export default new Vuex.Store({
  strict: false,
  plugins: [
    createPersistedState({
      paths: ['auth', 'language', 'necessary', 'v3', 'v4'],
    }),
  ],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    sidebar: false,
    sidebarShow: 'responsive',
    sidebarMinimize: false,
  },
  getters: {
    isUserLoggedIn: (state) => {
      return state.isUserLoggedIn;
    },
    getChangingSidebarStatus(state) {
      if (localStorage.getItem('sidebar')) {
        state.sidebar = localStorage.getItem('sidebar');
      }
      return state.sidebar;
    },
  },
  mutations: {
    setLoginToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
    },
    setLoginUser(state, user) {
      state.user = user;
    },
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : 'responsive';
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : 'responsive';
    },
    setChangingSidebar(state, input) {
      state.sidebar = input;
      localStorage.setItem('sidebar', input);
    },
  },
  actions: {
    setToken({commit}, token) {
      commit('setLoginToken', token);
    },
    setUser({commit}, user) {
      commit('setLoginUser', user);
    },
  },
  modules: {
    auth: Login,
    forgotPassword: ForgotPassword,
    signup: Signup,
    courses: Courses,
    overview: Overview,
    learning: LearningProfile,
    profile: Profile,
    updateProfile: UpdateProfile,
    template: Template,
    language: Language,
    score: Score,
    necessary: Necessary,
    v3: v3,
    'v3-data': v3Data,
    v4: v4,
    'v4-data': v4Data,
  },
});
